import { render, staticRenderFns } from "./TextViewFormatter.vue?vue&type=template&id=443706dc"
import script from "./TextViewFormatter.vue?vue&type=script&lang=js"
export * from "./TextViewFormatter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports